import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { InterviewContext } from "../../context/InterviewProvider";
import AudioWaveImg1 from "@workspace/main/src/assets/images/Audio Wave 1.png";
import AvnyFrameImg from "@workspace/main/src/assets/images/Avny Frame.png";
import { Transcript } from "@workspace/common";
import { interview } from "../../../../../helpers/backend_helper";
import { resetAddPreAssessmentData } from "@workspace/job/src/store/preAssessment/action";
import { interviewConductStatus } from "./interviewVideoChatConstant";
import { CoLogos } from "@workspace/common";
import { DOCUMENT_URL } from "@workspace/common/src/config";
import { BASE_DOCUMENTS } from "../../../../../helpers/url_helper";

const InterviewVideoChatPlatform = ({
  videoRecorderComponent,
  interviewAIComponent,
  interviewEndComponent,
  step,
  onCompleteInterview,
  jobId,
}) => {
  const dispatch = useDispatch();
  const interviewContext = useContext(InterviewContext);

  const isPreAssessmentDataSuccess = useSelector(
    (state) => state.PreAssessmentReducer.success
  );

  useEffect(() => {
    if (
      isPreAssessmentDataSuccess &&
      interviewContext?.interviewStatus === "save"
    ) {
      dispatch(resetAddPreAssessmentData());
      interviewContext.setInterviewStatus("return");
    }
  }, [isPreAssessmentDataSuccess]);

  useEffect(() => {
    if (
      interviewContext?.convertedVideoUrl &&
      // interviewContext?.chatHistory &&
      // interviewContext?.chatHistory.length > 0 &&
      // interviewContext?.botTimestamps &&
      interviewContext.interviewStatus === "save"
    ) {
      onCompleteInterview(
        interviewContext?.convertedVideoUrl,
        interviewContext?.chatHistory,
        interviewContext?.botTimestamps,
        false
      );
    }
  }, [
    interviewContext?.convertedVideoUrl,
    interviewContext?.chatHistory,
    interviewContext?.botTimestamps,
    interviewContext.interviewStatus,
  ]);

  useEffect(() => {
    if (step === 1) {
      interviewContext.startInterview();
    }

    if (step === 0) {
      if (
        interviewContext.interviewStatus != null &&
        interviewContext.interviewStatus !== "completed" &&
        interviewContext.interviewStatus !== "end"
      ) {
        interviewContext.setInterviewStatus("stop");
      }
    }
  }, [step]);

  // Handle the Back button press
  useEffect(() => {
    const handleBackButton = () => {
      interviewContext.setInterviewStatus("stop");
    };

    const handlePopState = (event) => {
      // Detect Back or Forward navigation
      if (step === 1) {
        handleBackButton();
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      interviewContext.setInterviewStatus("stop");
      interviewContext.abortRequest();
    };
  }, [step]);

  const generateStatus = () => {
    return <span className="shimmer-text">{interviewContext.botStatus}</span>;
  };

  return (
    <>
      {interviewContext?.interviewStatus === "completed" ? (
        interviewEndComponent
      ) : (
        <div
          className="d-flex"
          style={{
            height: "100vh",
            width: "100%",
          }}
        >
          <div
            className="d-flex flex-column"
            style={{
              width: "75%",
              backgroundColor: "#FFFFFF",
              padding: "15px 20px 20px 15px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="fs-4 fw-semibold">
                Welcome to Pulse Interview!
              </span>
              <span className="d-flex align-items-center gap-1">
                <span className="fs-5">Rec</span>
                <i
                  className="ri-record-circle-line fs-5"
                  style={{
                    color: "red",
                  }}
                ></i>
                <span
                  className="fw-semibold fs-5"
                  style={{
                    color: "#0A65CC",
                  }}
                >
                  {interviewContext?.elapsedTime}
                </span>
                <span className="fs-5" style={{}}>
                  min
                </span>
              </span>
            </div>

            <div className="flex-grow-1 d-flex justify-content-center align-items-center">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: "10px",
                  padding: "10px",
                  border: "1px solid #BED8FF",
                  backgroundColor: "#EEF3F8",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    width: "200px",
                    height: "auto",
                  }}
                >
                  <CoLogos
                    imgSrc={`${DOCUMENT_URL}${BASE_DOCUMENTS}/image/job/${jobId}`}
                  />
                </div>
                <img
                  src={AvnyFrameImg}
                  alt="Avny frame"
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    width: "180px",
                    height: "auto",
                  }}
                />
                {videoRecorderComponent}
              </div>
            </div>

            <div className="d-flex flex-column justify-content-center mt-1 align-items-center">
              <span className="my-3" style={{ fontSize: "16px" }}>
                {generateStatus()}
              </span>
              <img
                src={AudioWaveImg1}
                alt=""
                style={{
                  maxWidth: "150px", // Set a maximum width
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </div>
            <hr className="p-0 m-0 mt-2" />
            <div>{interviewAIComponent}</div>
          </div>

          {/* // Transcript */}
          <div
            className=""
            style={{
              width: "35%",
              backgroundColor: "#E6ECF0",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "10px 15px",
                height: "7.5vh",
              }}
            >
              <span className="fw-semibold fs-4">Interview Transcript</span>
            </div>
            <div
              style={{
                padding: "0px",
                height: "92.5vh",
                overflowY: "auto",
              }}
            >
              <Transcript
                chatHistory={interviewContext?.chatHistory}
                aiAlias="Interviewer"
                userAlias="Candidate"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InterviewVideoChatPlatform;
